import {POST} from "@/services/gateway";
import {trimString} from "@/components/common/utils/trimString";

const listItems = ({pagination, userIds, snapshotDateTime, folderId, searchTerm}) => {
  return POST('exchange/todo/search', {pagination, userIds, snapshotDateTime, folderId, searchTerm: trimString(searchTerm)});
}

const listTaskBreadcrumps = ({userId, folderId, snapshotDate}) => {
  return POST('exchange/todo/breadcrumbs', {userId, folderId, snapshotDate})
}

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, selectedIds, code}) => {
  return POST('exchange/todo/export', {snapshotDateTime, sourceIds, searchTerm: trimString(searchTerm), selectedIds}, {code: code ? code : null})
}

const restoreSnapshot = ({snapshotDateTime, sourceIds, searchTerm, destinationId, snapshotId, selectedIds, RestoreType, code}) => {
  return POST('exchange/todo/restore', {snapshotDateTime, sourceIds, searchTerm: trimString(searchTerm), destinationId, snapshotId, selectedIds, RestoreType}, {code: code ? code : null})
}

export {
  listItems,
  listTaskBreadcrumps,
  exportSnapshot,
  restoreSnapshot
}
